import axios from "axios";
import { ticketBaseURL } from "../config/api";

export const post_Checkout = async (data: any) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirCheckout/CheckoutAndCreateSubscription`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const post_RenewSubscription = async (data: any) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirCheckout/RenewSubscription`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const post_UpgradeSubscription = async (data: any) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirCheckout/UpgradeSubscription`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}
